module.exports = __webpack_public_path__ + "img/mbBanner10.51a9c983.png";